/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Taxonomy API documentation
 * This document list all APIs available for Taxonomy project
 * OpenAPI spec version: 1.0.4
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  TaxonDto,
  TaxonImageResponseDto,
  TaxonResponseDto,
  TaxonWithChildrenDto,
  TaxonsExistenceCheckBodyDto,
  TaxonsExistenceCheckResponseDto,
  TaxonsGetImageTaxonMatchBody,
  TaxonsGetTaxonMatchParams,
  TaxonsGetTaxonsParams,
} from '.././model';

import { apiInstance } from '../../taxonomyApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Search for taxons
 */
export const Taxons_getTaxons = (
  params: TaxonsGetTaxonsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TaxonResponseDto>(
    { url: `/api/taxons`, method: 'GET', params, signal },
    options,
  );
};

export const getTaxonsGetTaxonsQueryKey = (params?: TaxonsGetTaxonsParams) => {
  return ['api', 'taxons', ...(params ? [params] : [])] as const;
};

export const getTaxonsGetTaxonsQueryOptions = <
  TData = Awaited<ReturnType<typeof Taxons_getTaxons>>,
  TError = unknown,
>(
  params: TaxonsGetTaxonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTaxonsGetTaxonsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Taxons_getTaxons>>
  > = ({ signal }) => Taxons_getTaxons(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Taxons_getTaxons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TaxonsGetTaxonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof Taxons_getTaxons>>
>;
export type TaxonsGetTaxonsQueryError = unknown;

export function useTaxonsGetTaxons<
  TData = Awaited<ReturnType<typeof Taxons_getTaxons>>,
  TError = unknown,
>(
  params: TaxonsGetTaxonsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxons>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Taxons_getTaxons>>,
          TError,
          Awaited<ReturnType<typeof Taxons_getTaxons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTaxonsGetTaxons<
  TData = Awaited<ReturnType<typeof Taxons_getTaxons>>,
  TError = unknown,
>(
  params: TaxonsGetTaxonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxons>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Taxons_getTaxons>>,
          TError,
          Awaited<ReturnType<typeof Taxons_getTaxons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTaxonsGetTaxons<
  TData = Awaited<ReturnType<typeof Taxons_getTaxons>>,
  TError = unknown,
>(
  params: TaxonsGetTaxonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search for taxons
 */

export function useTaxonsGetTaxons<
  TData = Awaited<ReturnType<typeof Taxons_getTaxons>>,
  TError = unknown,
>(
  params: TaxonsGetTaxonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTaxonsGetTaxonsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the closest taxon match
 */
export const Taxons_getTaxonMatch = (
  params: TaxonsGetTaxonMatchParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TaxonDto>(
    { url: `/api/taxons/match`, method: 'GET', params, signal },
    options,
  );
};

export const getTaxonsGetTaxonMatchQueryKey = (
  params?: TaxonsGetTaxonMatchParams,
) => {
  return ['api', 'taxons', 'match', ...(params ? [params] : [])] as const;
};

export const getTaxonsGetTaxonMatchQueryOptions = <
  TData = Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
  TError = void,
>(
  params: TaxonsGetTaxonMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTaxonsGetTaxonMatchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof Taxons_getTaxonMatch>>
  > = ({ signal }) => Taxons_getTaxonMatch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TaxonsGetTaxonMatchQueryResult = NonNullable<
  Awaited<ReturnType<typeof Taxons_getTaxonMatch>>
>;
export type TaxonsGetTaxonMatchQueryError = void;

export function useTaxonsGetTaxonMatch<
  TData = Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
  TError = void,
>(
  params: TaxonsGetTaxonMatchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
          TError,
          Awaited<ReturnType<typeof Taxons_getTaxonMatch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTaxonsGetTaxonMatch<
  TData = Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
  TError = void,
>(
  params: TaxonsGetTaxonMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
          TError,
          Awaited<ReturnType<typeof Taxons_getTaxonMatch>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTaxonsGetTaxonMatch<
  TData = Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
  TError = void,
>(
  params: TaxonsGetTaxonMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the closest taxon match
 */

export function useTaxonsGetTaxonMatch<
  TData = Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
  TError = void,
>(
  params: TaxonsGetTaxonMatchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxonMatch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTaxonsGetTaxonMatchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the closest taxon match
 */
export const Taxons_getImageTaxonMatch = (
  taxonsGetImageTaxonMatchBody: TaxonsGetImageTaxonMatchBody,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (taxonsGetImageTaxonMatchBody.file !== undefined) {
    formData.append(`file`, taxonsGetImageTaxonMatchBody.file);
  }

  return apiInstance<TaxonImageResponseDto>(
    {
      url: `/api/taxons/match`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getTaxonsGetImageTaxonMatchMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Taxons_getImageTaxonMatch>>,
    TError,
    { data: TaxonsGetImageTaxonMatchBody },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Taxons_getImageTaxonMatch>>,
  TError,
  { data: TaxonsGetImageTaxonMatchBody },
  TContext
> => {
  const mutationKey = ['taxonsGetImageTaxonMatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Taxons_getImageTaxonMatch>>,
    { data: TaxonsGetImageTaxonMatchBody }
  > = (props) => {
    const { data } = props ?? {};

    return Taxons_getImageTaxonMatch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TaxonsGetImageTaxonMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof Taxons_getImageTaxonMatch>>
>;
export type TaxonsGetImageTaxonMatchMutationBody = TaxonsGetImageTaxonMatchBody;
export type TaxonsGetImageTaxonMatchMutationError = void;

/**
 * @summary Get the closest taxon match
 */
export const useTaxonsGetImageTaxonMatch = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Taxons_getImageTaxonMatch>>,
      TError,
      { data: TaxonsGetImageTaxonMatchBody },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Taxons_getImageTaxonMatch>>,
  TError,
  { data: TaxonsGetImageTaxonMatchBody },
  TContext
> => {
  const mutationOptions = getTaxonsGetImageTaxonMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get taxon by its code
 */
export const Taxons_getTaxon = (
  taxonCode: string,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TaxonWithChildrenDto>(
    { url: `/api/taxons/${taxonCode}`, method: 'GET', signal },
    options,
  );
};

export const getTaxonsGetTaxonQueryKey = (taxonCode?: string) => {
  return ['api', 'taxons', taxonCode] as const;
};

export const getTaxonsGetTaxonQueryOptions = <
  TData = Awaited<ReturnType<typeof Taxons_getTaxon>>,
  TError = void,
>(
  taxonCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxon>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTaxonsGetTaxonQueryKey(taxonCode);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof Taxons_getTaxon>>> = ({
    signal,
  }) => Taxons_getTaxon(taxonCode, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!taxonCode,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof Taxons_getTaxon>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TaxonsGetTaxonQueryResult = NonNullable<
  Awaited<ReturnType<typeof Taxons_getTaxon>>
>;
export type TaxonsGetTaxonQueryError = void;

export function useTaxonsGetTaxon<
  TData = Awaited<ReturnType<typeof Taxons_getTaxon>>,
  TError = void,
>(
  taxonCode: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxon>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Taxons_getTaxon>>,
          TError,
          Awaited<ReturnType<typeof Taxons_getTaxon>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTaxonsGetTaxon<
  TData = Awaited<ReturnType<typeof Taxons_getTaxon>>,
  TError = void,
>(
  taxonCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxon>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Taxons_getTaxon>>,
          TError,
          Awaited<ReturnType<typeof Taxons_getTaxon>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTaxonsGetTaxon<
  TData = Awaited<ReturnType<typeof Taxons_getTaxon>>,
  TError = void,
>(
  taxonCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxon>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get taxon by its code
 */

export function useTaxonsGetTaxon<
  TData = Awaited<ReturnType<typeof Taxons_getTaxon>>,
  TError = void,
>(
  taxonCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof Taxons_getTaxon>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTaxonsGetTaxonQueryOptions(taxonCode, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Check if a batch of taxon exists in database
 */
export const Taxons_getTaxonsByName = (
  taxonsExistenceCheckBodyDto: TaxonsExistenceCheckBodyDto,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TaxonsExistenceCheckResponseDto>(
    {
      url: `/api/taxons/existence-check`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: taxonsExistenceCheckBodyDto,
      signal,
    },
    options,
  );
};

export const getTaxonsGetTaxonsByNameMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof Taxons_getTaxonsByName>>,
    TError,
    { data: TaxonsExistenceCheckBodyDto },
    TContext
  >;
  request?: SecondParameter<typeof apiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof Taxons_getTaxonsByName>>,
  TError,
  { data: TaxonsExistenceCheckBodyDto },
  TContext
> => {
  const mutationKey = ['taxonsGetTaxonsByName'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof Taxons_getTaxonsByName>>,
    { data: TaxonsExistenceCheckBodyDto }
  > = (props) => {
    const { data } = props ?? {};

    return Taxons_getTaxonsByName(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TaxonsGetTaxonsByNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof Taxons_getTaxonsByName>>
>;
export type TaxonsGetTaxonsByNameMutationBody = TaxonsExistenceCheckBodyDto;
export type TaxonsGetTaxonsByNameMutationError = unknown;

/**
 * @summary Check if a batch of taxon exists in database
 */
export const useTaxonsGetTaxonsByName = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof Taxons_getTaxonsByName>>,
      TError,
      { data: TaxonsExistenceCheckBodyDto },
      TContext
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof Taxons_getTaxonsByName>>,
  TError,
  { data: TaxonsExistenceCheckBodyDto },
  TContext
> => {
  const mutationOptions = getTaxonsGetTaxonsByNameMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
